module.exports = __webpack_public_path__ + "img/SKMJ_ex6.7567db96.jpg";